<app-window [title]="title">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item ">
            <a class="nav-link active" id="profile-tab" data-toggle="tab" href="#tabDossierPhase1" role="tab" aria-controls="profile" aria-selected="false">
                <i class="far fa-clipboard"></i><span class="d-none d-sm-inline-block ml-2">Generalità</span></a>
        </li>
        <li *ngIf="record.sections" class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#tabDossierPhase2" role="tab" aria-controls="profile" aria-selected="false">
                <i class="fas fa-edit"></i><span class="d-none d-sm-inline-block ml-2">Dati</span></a>
        </li>

        <li *ngIf="record.sections" class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#tabDossierPhase3" role="tab" aria-controls="profile" aria-selected="false">
                <i class="far fa-bell"></i><span class="d-none d-sm-inline-block ml-2">Allarmi</span></a>
        </li>
    </ul>
    
    <div class="tab-content" id="myTabContent">

        <!-- GENERALITA' -->
        <div class="tab-pane fade show active" id="tabDossierPhase1" role="tabpanel" aria-labelledby="tabDossierPhase1-tab">
            <form role="form" id="detailForm" *ngIf="record">                    
                <div class="row">
                    <div class="col-lg-8">
                        <div class="form-group mb-1">
                            <label>Titolo</label>
                            <div class="input-group" >
                                <input class="form-control form-control-sm" type="text"  name="title"  [(ngModel)]="record.title"  />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <app-type [id_type]="record.id_type" [class]="" [table]="'dossier'" [record]="record" ></app-type>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-1">
                            <label>Descrizione</label>
                            <div class="input-group" >
                                <textarea class="form-control form-control-sm" row="5" name="description"  [(ngModel)]="record.description" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                
                <small *ngIf="!record.sections"><i class="text-gray fa fa-2x fa-exclamation-circle mr-2"></i>Salva per poter procedere con l'immisione degli altri dati.</small>

            </form>
        </div>

        <!-- CAMPI -->
        <div class="tab-pane fade " id="tabDossierPhase2" role="tabpanel" aria-labelledby="tabDossierPhase2-tab">
            <div class="row">
                <div class="col-12">                        
                    <app-fields [sections]="record.sections"></app-fields>
                </div>
            </div>
        </div>

        <!-- ALLARMI -->
        <div class="tab-pane fade " id="tabDossierPhase3" role="tabpanel" aria-labelledby="tabDossierPhase3-tab">
            <div *ngIf="!record.alarms || record.alarms.length==0" class="m-5 text-center text-secondary">
                <i class="icon fas fa-info-circle mr-2"></i>
                <i>Nessun allarme impostato!</i><br>
                <button class="btn btn-outline-success btn-sm mt-3" (click)="addAlarm()"><i class="fa fa-plus mr-2"></i>Aggiungi Allarme</button>
            </div>              
            <table class="table table-sm mt-3" *ngIf="record.alarms">
                <thead>
                    <th>Descrizione</th>
                    <th>Condizione <i class="fa fa-exclamation-circle help text-gray" title="Indica il nome dei campi all'interno doppie parentesi graffe ed utilizza gli operatori logici (=, !=, >, <)"></i></th>
                    <th>Notifica <i class="fa fa-exclamation-circle help text-gray" title="Nel testo della notifica fare riferimento ai campi con: &#123; &#123; f o r m . I D _ F A S E . I D _ C A M P O &#125; &#125;"></i></th>
                    <th>Data di riferimento <i class="fa fa-exclamation-circle help text-gray" title="Indica il nome di un campo all'interno di doppie parentesi graffe: &#123;&#123;NOME_CAMPO&#125;&#125;"></i></th>
                    <th>Giorni prima della scadenza <i class="fa fa-exclamation-circle help text-gray" title="Nella notifica indica con &#123;&#123;day_left&#125;&#125; i giorni mancanti. Puoi indicare più giorni separandoli con la virgola."></i></th>
                    <th>Tipo allarme</th>
                    <th>Messaggio allarme</th>
                    <th></th>
                </thead>
                <tbody>                               
                    <tr *ngFor="let a of record.alarms">
                        <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="a.description">
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="a.condition">
                        </td>
                        <td> 
                            <select class="form-control form-control-sm" [(ngModel)]="a.id_notification">
                                <option *ngFor="let n of notifications" [ngValue]="n.id">{{n.name}}</option>
                            </select>                                        
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="a.date">
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="a.days">
                        </td>
                        <td>
                            <select class="form-control form-control-sm" [(ngModel)]="a.type_error">
                                <option value="warning">Avvertenza</option> 
                                <option value="danger">Critico</option>                                                                               
                            </select>
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="a.message_error">                                     
                        </td>
                        <td>
                            <button class="btn btn-xs btn-danger float-right" (click)="deleteAlarm(a)"><i class="fa fa-trash"></i></button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-center">
                            <button class="btn btn-outline-success btn-sm btn-block" (click)="addAlarm()"><i class="fa fa-plus mr-2"></i>Aggiungi Allarme</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-2" *ngIf="notifyChangePhase">
                    <div class="col-lg-12 mb-3">
                        <h5>Notifica per cambio fase</h5>
                        <i><small>Indicare la durata prevista per lo sviluppo della fase, il modello da utilizzare per la notifica e quanti giorni prima della scadenza inviare la notifica.<br> 
                        (Indicando una durata ed una scadenza uguale la notifica sarà inviata al cambio della fase!)</small></i>
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group mb-1">
                            <label>Durata della fase <small>(in giorni)</small></label>
                            <div class="input-group" >
                                <input type="number" class="form-control form-control-sm"  name="duration"  [(ngModel)]="record.duration" >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-1">
                            <label>Modello di notifica <small>(per stati di NON chiusura della fase)</small></label>
                            <div class="input-group" >                                    
                                <select class="form-control form-control-sm" name="id_notification"[(ngModel)]="record.id_notification">
                                    <option *ngFor="let n of notifications" [ngValue]="n.id">{{n.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group mb-1">
                            <label>Giorni prima della scadenza <i class="fa fa-exclamation-circle help text-gray" title="Indicare il numero di giorni prima della scadenza per inviare la notifica (è possibile indicare più giorni separando i valori con la virgola ex. 20,10,6,2)"></i></label>
                            <div class="input-group" >
                                <input type="text" class="form-control form-control-sm" name="alarmday" [(ngModel)]="record.alarmday" >                                  
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>

    <app-toolbarmodel [model]="this" [showSave]="true" [showSaveAndClose]="true"></app-toolbarmodel>
</app-window>